import {eq} from '@shared/helpers/lang'

import {ProcessStatus, ProcessStatusValues} from '@web/slices/shoppingSubscription/slice'

import {
    SubscriptionCompletionUnknownStatusList,
    SubscriptionInProgressStatusList,
    SubscriptionPreparedStatusList,
    SubscriptionProcessStatusValues,
    SubscriptionSuccessStatusList,
    SubscriptionProcessExceptionCode,
    SubscriptionProcessExceptionCodeValues,
} from '../../constants'

/** 성공적으로 상태를 수신한 경우 상태를 결제FE 내부에서 관리하는 process status로 변환 */
export const getProcessStatus = (value: SubscriptionProcessStatusValues): ProcessStatusValues => {
    if (SubscriptionPreparedStatusList.includes(value)) {
        return ProcessStatus.READY
    } else if (SubscriptionInProgressStatusList.includes(value)) {
        return ProcessStatus.PENDING
    } else if (SubscriptionSuccessStatusList.includes(value)) {
        return ProcessStatus.SUCCESS
    } else if (SubscriptionCompletionUnknownStatusList.includes(value)) {
        return ProcessStatus.UNKNOWN
    } else {
        return ProcessStatus.FAIL
    }
}

/** api 오류로 에러코드를 수신한 경우 결제FE 내부에서 관리하는 process status로 변환 */
export const getProcessExceptionStatus = (value: SubscriptionProcessExceptionCodeValues): ProcessStatusValues => {
    const eqStatus = eq(value)

    if (eqStatus(SubscriptionProcessExceptionCode.SUBSCRIPTION_PROCESS_NOT_FOUND)) {
        return ProcessStatus.NOT_READY
    } else if (eqStatus(SubscriptionProcessExceptionCode.REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT)) {
        return ProcessStatus.UNKNOWN
    }

    return ProcessStatus.FAIL
}
